<template>
  <div class="lesson-content">
    <span class="lesson-meta">
      <span class="lesson-kab">
        <a v-if="kabLink" :href="kabLink.href" target="_blank" rel="noopener noreferrer" @click.stop>{{ kabLink.text }}</a>
        <template v-else>{{ lesson.kab }}</template>
      </span>
      <span class="lesson-oldkab" v-if="lesson?.oldkab">{{ lesson.oldkab }}</span>
      {{ lesson.type.slice(0,3) }}
      <template v-for="(g, gi) in groupNames">
        <button :key="gi" type="button" class="group-chip" :title="'Журнал группы ' + g"
          @click="$emit('groups-click', g)">{{ g }}</button><span :key="'sep-' + gi" v-if="gi < groupNames.length - 1">, </span>
      </template>
      <span v-if="subgroupLabel" class="lesson-subgroup" :title="'По расписанию кафедры: ' + lesson.subgroups">{{ subgroupLabel }}</span>
      <button v-if="lesson.in_iss == 1" type="button" class="iss-mark" @click="issCheckClick()" title="Занятие уже в журнале. Кликнуть для снятия отметки." aria-label="Снять отметку «в журнале»">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
          <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
        </svg>
      </button>
      <button v-if="lesson.log" type="button" class="lesson-status"
        @click="winLogShow(lesson.log)"
        :style="'color: ' + ((lesson.color == 'blue')?'#0d6efd':lesson.color)"
        title="Показать журнал">{{ lesson.status }}</button>
      <span v-else-if="lesson.status" class="lesson-status"
        :style="'color: ' + ((lesson.color == 'blue')?'#0d6efd':lesson.color)">{{ lesson.status }}</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'lessonContent',
  props: {
    lesson: Object,
    hideCopyLabel: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    groupNames() {
      const g = this.lesson.groups
      if (Array.isArray(g)) return g.filter(Boolean)
      if (typeof g === 'string' && g) return [g]
      return []
    },
    // "УТб-2301-02-00, 1 подгруппа" -> "1 подгр."
    subgroupLabel() {
      const s = this.lesson.subgroups
      if (typeof s !== 'string' || !s) return ''
      const nums = [...new Set((s.match(/\d+(?= подгруппа)/g) || []))]
      return nums.length ? nums.join(', ') + ' подгр.' : ''
    },
    // ВятГУ для дистанционных занятий кладёт в поле "Кабинет" готовый HTML
    // вида <a href="...">Занятие удалённо в МТС Линк</a>. Не используем
    // v-html (XSS) — парсим через DOMParser (ничего не вставляется в DOM),
    // достаём href/текст и рендерим обычным Vue-биндингом (авто-экранирование
    // текста, схема ссылки проверена). Если тега <a> нет или схема не
    // http(s) — просто показываем текст как раньше.
    kabLink() {
      const raw = this.lesson.kab
      if (typeof raw !== 'string' || raw.indexOf('<a') === -1) return null
      try {
        const a = new DOMParser().parseFromString(raw, 'text/html').querySelector('a')
        const href = a && a.getAttribute('href')
        if (href && /^https?:\/\//i.test(href)) {
          return { href, text: a.textContent.trim() || href }
        }
      } catch (e) { /* некорректный HTML — покажем как обычный текст */ }
      return null
    }
  },
  methods: {
    winLogShow (log) {
      // окно открывает App (openWinLog) — ему нужна и работа ISS занятия
      if (log) this.$emit('set-win-log', log)
    },
    issCheckClick() {
      this.$emit('iss-check-click')
    }
  }
}
</script>

<style scoped>
.lesson-content {
  padding-left: 6px;
}
.lesson-meta {
  font-size: 80%;
}
.lesson-kab {
  font-weight: bold;
}
.lesson-oldkab {
  font-weight: bold;
  text-decoration: line-through;
  color: red;
}
.iss-mark {
  color: green;
  background: none;
  border: 0;
  padding: 0;
  line-height: 1;
  vertical-align: middle;
  min-width: 24px;
  min-height: 24px;
}
.lesson-status {
  background: none;
  border: 0;
  padding: 0;
  color: inherit;
  font: inherit;
  text-align: left;
  text-decoration: underline;
  cursor: pointer;
}

/* подгруппа из расписания кафедры */
.lesson-subgroup {
  margin-left: 4px;
  padding: 0 6px;
  border-radius: 8px;
  background-color: var(--bg-muted);
  border: 1px solid var(--border);
  color: var(--text);
  white-space: nowrap;
  cursor: help;
}

/* кликабельное название группы — открывает состав группы */
.group-chip {
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  color: var(--primary);
  cursor: pointer;
  text-decoration: none;
}
.group-chip:hover {
  text-decoration: underline;
}
</style>
